import { Directive, Input, OnChanges, SimpleChanges, ChangeDetectorRef } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[appSlugTransform]',
  standalone: true
})
export class SlugTransformDirective implements OnChanges {
  @Input() appSlugTransform!: string;

  constructor(private model: NgModel, private cdr: ChangeDetectorRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['appSlugTransform'] && changes['appSlugTransform'].currentValue !== changes['appSlugTransform'].previousValue) {
      const newValue = this.transform(changes['appSlugTransform'].currentValue);
      this.model.control.setValue(newValue, { emitEvent: false });
      this.cdr.detectChanges(); // Trigger change detection manually
    }
  }

  private transform(value: string): string {
    if (!value) return '';

    let text = value.toLowerCase().trim();
    text = text.replace(/ +/g, '-'); // Replace spaces with hyphens
    text = text.replace(/--+/g, '-'); // Replace multiple hyphens with a single one
    text = text.normalize('NFKD').replace(/[\u0300-\u036f]/g, ''); // Remove diacritics
    text = text.replace(/[^a-zA-Z0-9-]/g, ''); // Remove invalid characters

    return text;
  }
}
